import { useFormikContext } from 'formik';
import { OfferType, PromoterDiscountType } from 'legacy/events/types';
import React, { useState } from 'react';
import PromoterDiscountCodeForm from '../PromoterDiscountCodeForm';
import PromoterDiscountCard from '../PromoterDiscountCard';

const PromoterDiscount = ({ eventId }: { eventId: string }) => {
  const { values, setFieldValue } = useFormikContext<OfferType>();
  const [shouldShowCreateForm, setShouldShowCreateForm] = useState(false);
  const promoterDiscount = values.discount;

  const handleCreateDiscountCode = (discountCode) => {
    setShouldShowCreateForm(false);
    const promoterDiscount: PromoterDiscountType = {
      value: discountCode.value,
      kind: discountCode.kind as 'amount' | 'percentage',
      usageLimitPerContract: discountCode.maxUsage,
      startDate: discountCode.startDate,
      endDate: discountCode.endDate
    };
    setFieldValue('discount', promoterDiscount);
  };

  const handleCloseCreateForm = () => {
    setShouldShowCreateForm(false);
  };

  return (
    <div>
      {!promoterDiscount ? (
        <div
          className="text-sm font-bold text-[#3853C4] cursor-pointer mt-4"
          onClick={() => setShouldShowCreateForm(true)}
        >
          + Set Purchaser Discount
        </div>
      ) : (
        <PromoterDiscountCard
          setShouldShowCreateForm={setShouldShowCreateForm}
        />
      )}
      {shouldShowCreateForm && (
        <PromoterDiscountCodeForm
          eventId={eventId}
          onSubmit={handleCreateDiscountCode}
          onClose={handleCloseCreateForm}
          initialValues={promoterDiscount}
        />
      )}
    </div>
  );
};

export default PromoterDiscount;
